<template>
	<form v-on:submit.prevent="validateBeforeSubmit">
		<div class="row">
			<div class="col-12">
				<div class="form-group">
					<ejs-combobox v-model="object" id="object" :dataSource='dataSourceAudit' :fields='fieldsSourceAudit' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textReports.textFormObject')"></ejs-combobox>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<ejs-datepicker v-model="dateMin" :max="dateMax" start='Decade' :placeholder="$t('textReports.textFormStartdate')"></ejs-datepicker>
				</div>
			</div>
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<ejs-datepicker v-model="dateMax" :min="dateMin" start='Decade' :placeholder="$t('textReports.textFormFinaldate')"></ejs-datepicker>
				</div>
			</div>
		</div>
		<ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtn" :disabled="disabledButton" :spinSettings="spinSettings" :progress="progress" :duration="50000">{{ $t('textBtn.btnSearch') }}</ejs-progressbutton>
	</form>
</template>

<script>
import axios from 'axios'
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars'
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { enableRipple } from '@syncfusion/ej2-base';

enableRipple(true);
Vue.use(ProgressButtonPlugin);
Vue.use(DatePickerPlugin);

export default {
	name: "reports-form-detail-audit",
	props: ['tittle'],
	data(){
		return {
			object : null,
			dataSourceAudit: [],
			fieldsSourceAudit: { text: "nombre", value: 'id' },
			dateMin: null,
			dateMax: null,
			spinSettings: { position: 'Right', width: 20 },
			disabledButton :false,
			responseReport: false,
			activeFilters: []
		}
	},
	methods: {
		initFormReportsDetailAudit: function() {
			this.dataSourceAudit = [];
			axios.post('/auth/reports/structuring/getAllObjects').then(response => {
				this.dataSourceAudit = response.data;
			});
		},
		validateBeforeSubmit: function() {
			this.disabledButton = true;
      this.responseReport = false;
			this.$refs.progressBtn.enable;
			const data = {
        tenant_id: localStorage.getItem('TID'),
				object: this.object,
				dateMin: this.dateMin,
				dateMax: this.dateMax
      };
			axios.post('/auth/reports/structuring/getDetailAudit', data).then(response => {
				if(this.dateMin !== null && this.dateMin !== "")  this.activeFilters.push('Desde - ' + this.dateMin.toISOString().substring(0, 10)); 
				if(this.dateMax !== null && this.dateMax !== "")  this.activeFilters.push('Hasta - ' + this.dateMax.toISOString().substring(0, 10));
				this.responseReport = true;
				Vue.prototype.$eventHub.$emit('loadDataReports', this.$props.tittle, response.data, this.activeFilters.join(' / '));
			});
		},
		progress: function() {
			if(this.responseReport){
				this.$refs.progressBtn.stop();
			}
		}
	},
	created: function() {
		this.initFormReportsDetailAudit();
		this.$eventHub.$on('onResetSwitchTenants', this.initFormReportsDetailAudit);
	}
}
</script>